// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2H6WU","field":"styles_field__Xy9dx","fieldCol":"styles_fieldCol__2m189","diffCol":"styles_diffCol__2cWlz","diff":"styles_diff__1ooka"};